import React from 'react'
import LoginForm from "../whitaijiFrontendLibrary/auth/components/LoginForm"

const Login = ({AuthContext}) => {

  return (
    <div>
      <LoginForm AuthContext={AuthContext}/>
    </div>

  )
}

export default Login